import React, { useState, useEffect } from 'react';
import styles from '../static/styles/CompletedTasks.module.css';

import firstTaskBG from '../static/img/DailyTasks/iconCompletedBG.svg';
import dummyImg from '../static/img/DailyCheckin/iconDailyTaskDummy.png';
import { fetchCompletedTasks } from '../api/challenges';

const CompletedTasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [gameName, setGameName] = useState('');

  useEffect(() => {

    document.title = 'Completed Tasks | Ufone ESG';

    const fetchTasks = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetchCompletedTasks();
        // console.log('API Response:', response);

        if (response && response.data) {
          const completedTasks = response.data.map((challenge, index) => ({
            id: challenge.challenge_uuid || index + 1,
            title: challenge.challenge_name || 'Challenge',
            reward: `Win ${challenge.prize || '0'} Credits`,
            image: challenge.thumbnail || dummyImg,
            claimed: true,
          }));
          setTasks(completedTasks);
        } else {
          setTasks([]);
        }
      } catch (err) {
        setError('Error loading tasks');
        setTasks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, []);

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}><span>Completed Tasks</span></h2>
      {/* <p className={styles.subheading}>View your completed daily tasks</p> */}

      {loading && <div className={styles.loading}>Loading tasks...</div>}
      {error && <div className={styles.error}>Error</div>}

      <div className={styles.tasksContainer}>
        {tasks.length > 0 ? (
          tasks.map((task, index) => (
            <div
              key={task.id}
              className={styles.taskCard}
              style={index === 0 ? { paddingTop: '35px', backgroundImage: `url(${firstTaskBG})`, backgroundSize: 'cover', border: 'none', borderLeft: '4px solid white' } : {}}
            >
              <div className={styles.taskText}>
                <p className={styles.taskTitle}>{task.title}</p>
                <p className={styles.taskReward}>{task.reward}</p>
              </div>
              <img
                src={task.image}
                alt={`Task ${index + 1}`}
                className={styles.taskImage}
              />
              <div className={styles.claimed}>CLAIMED</div>
            </div>
          ))
        ) : !loading && !error && (
          <div className={styles.noTasks}>No completed tasks available</div>
        )}
      </div>
    </div>
  );
};

export default CompletedTasks;